import Base from './Base';

export default class TollFreeProfile extends Base {
    get hasNumbers() {
        return Boolean(this.numbers.length);
    }

    get hasOptInMethods() {
        return Boolean(this.opt_in_methods.length);
    }

    get countNumbers() {
        return this.numbers.length;
    }

    get idsNumbers() {
        return this.numbers.map(item => item.id);
    }

    get textNumbers() {
        return this.numbers
            .map(item => `${item.formatted_number}: ${item.numberable ? item.numberable.name : 'No inbox'}`)
            .join('\n');
    }

    get hasStep1() {
        return Boolean(
            this.title &&
            this.monthly_volume
        );
    }

    get hasStep2() {
        return Boolean(
            this.use_case_id &&
            this.use_case_description
        );
    }

    get hasStep3() {
        return Boolean(
            this.sample_message_1 &&
            this.sample_message_2
        );
    }

    get hasStep4() {
        return Boolean(this.opt_in_methods.length);
    }

    get hasStep5() {
        return Boolean(this.numbers.length);
    }

    get status() {
        if (this.completed) return 'active';

        return 'incomplete';
    }

    get statusActive() {
        return this.status === 'active';
    }

    get statusIncomplete() {
        return this.status === 'incomplete';
    }

    get statusStyles() {
        if (this.statusActive) {
            return {
                color: '#13cb6e',
            };
        }

        return {
            color: '#da5350',
        };
    }

    get statusLabel() {
        if (this.statusActive) {
            return 'Active';
        }

        return 'Incomplete';
    }
}
